import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import { StateController } from '../state';
import type { Package, RelatedPackage } from '../components';

@customElement('umb-market-package-footer')
export class UmbMarketPackageFooter extends LitElement {
  // accepts the full package model as we need multiple related package fields (4)
  @property({ type: Object })
  package!: Package;

  // eslint-disable-next-line class-methods-use-this
  #renderCardDeck(cards: RelatedPackage[], header: string) {
    return html`<umb-market-card-deck .header=${header} context="footer"
      >${cards.map(
        card =>
          html`<umb-market-package-card
            ?deck=${true}
            .package=${card as Package}
            .packageId=${card.packageId}
          ></umb-market-package-card>`
      )}</umb-market-card-deck
    >`;
  }

  render() {
    if (StateController.isEmbedView) {
      return null;
    }

    return html`
      <footer>
        ${when(this.package.groupedRelatedPackagesSelected?.length, () =>
          this.package.groupedRelatedPackagesSelected.map(g =>
            this.#renderCardDeck(g.relatedPackages, g.title)
          )
        )}
        ${when(
          this.package.relatedPackagesSelected.length &&
            !this.package.groupedRelatedPackagesSelected?.length,
          () =>
            this.#renderCardDeck(
              this.package.relatedPackagesSelected,
              'Related packages'
            )
        )}
        ${when(this.package.relatedPackagesRequiredForUmbracoCloud.length, () =>
          this.#renderCardDeck(
            this.package.relatedPackagesRequiredForUmbracoCloud,
            'Extensions required for Umbraco Cloud'
          )
        )}
        ${when(this.package.relatedPackagesBySameAuthor.length, () =>
          this.#renderCardDeck(
            this.package.relatedPackagesBySameAuthor,
            'Other packages by this author'
          )
        )}
        ${when(this.package.subPackages.length, () =>
          this.#renderCardDeck(
            this.package.subPackages,
            'Packages dependent on this package'
          )
        )}
      </footer>
    `;
  }

  static styles = [
    css`
      footer {
        display: flex;
        flex-direction: column;
        padding: var(--l-spacer) var(--s-spacer);
      }

      @media (min-width: 900px) {
        footer {
          padding: var(--xl-spacer) var(--l-spacer);
        }
      }

      umb-market-card-deck {
        max-width: var(--max-width);
        margin-top: 0;
      }

      umb-market-card-deck + umb-market-card-deck {
        margin-top: var(--xl-spacer);
      }
    `,
  ];
}
